import React from 'react';
import { BG_COLORS, FACILITIES } from '../data/schoolData';

export default function FacilitiesPage() {
  return (
    <>
      <div className="page-hero">
        <h2>Our Facilities</h2>
        <p>World-class infrastructure for world-class young learners</p>
      </div>
      <section className="facilities" style={{paddingTop:'70px'}}>
        <div className="container">
          <div className="facilities-grid">
            {FACILITIES.map((f,i) => (
              <div className="facility-card" key={i}>
                <div className="facility-img" style={{background:BG_COLORS[i],display:'flex',alignItems:'center',justifyContent:'center',fontSize:'72px'}}>{f.emoji}</div>
                <div className="facility-body">
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
